import { ReactNode, useContext, useMemo, useState } from 'react'
import { PanNumberContext } from './PanNumberContext'
import { useCustomUser } from './CustomUserProvider'

export const usePanNumber = () => useContext(PanNumberContext)

const PanNumberProvider = ({ children }: { children: ReactNode }) => {
  const { user } = useCustomUser()

  const [maskedPanNumber, setMaskedPanNumber] = useState<string | undefined>(user?.maskedPan)

  const value = useMemo(
    () => ({ maskedPanNumber, setMaskedPanNumber }),
    [maskedPanNumber, setMaskedPanNumber]
  )

  return <PanNumberContext.Provider value={value}>{children}</PanNumberContext.Provider>
}

export default PanNumberProvider
